import { defineGameCard, onResolve } from '../authoring/index.js';
import { slimeDependencies, totalResidueForPlayer } from './slime-helpers.js';
export const DeepSampleCard = defineGameCard({
    id: 'deep_sample',
    gameplay: {
        type: 'SPELL', cost: 2,
    },
    presentation: {
        name: 'Глубинная проба',
        description: 'Возьмите 1 карту. Если на вашей стороне поля больше 3 Склизи, возьмите ещё 1.',
        glyph: {
            colors: ['#10213A', '#525F72', '#4C3F3F', '#728A3C', '#7B4F2F'],
            rows: [
                '........1221........',
                '.......122231.......',
                '........1111........',
                '......12222231......',
                '......1333331.......',
                '.......122331.......',
                '.......122231.......',
                '........1231........',
                '........1331........',
                '.......4444222......',
                '....................',
                '.......111.111......',
                '..111.12431221.111..',
                '.153311222322115551.',
                '15553314444441553551',
                '15555312244441535551',
                '15555514224441555531',
                '15555514444441555331',
                '13355534442425533331',
                '.111111111111111111.',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [onResolve((ctx) => {
            const controllerId = ctx.self?.controllerId;
            if (controllerId === undefined)
                return;
            const stacks = totalResidueForPlayer(ctx, controllerId);
            ctx.ops.drawCard(controllerId, stacks > 3 ? 2 : 1);
        })],
    ui: {
        mechanics: ['slime_residue'],
    },
});
//# sourceMappingURL=deep_sample.js.map